// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sales-message {
  margin: 16px auto;
  padding: 16px 20px;
  max-width: 900px;
  background: linear-gradient(135deg, #fff8e1 0%, #fff3cd 100%);
  border: 1px solid #ffe082;
  border-right: 4px solid #ffa726;
  border-radius: 12px;
  color: #5d4037;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.6;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  direction: rtl;
}
@media (max-width: 768px) {
  .sales-message {
    margin: 12px 10px;
    padding: 12px 14px;
    font-size: 14px;
    border-radius: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/core/pages/sales/sales.page.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6DAAA;EACA,yBAAA;EACA,+BAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;EACA,cAAA;AACF;AACE;EAhBF;IAiBI,iBAAA;IACA,kBAAA;IACA,eAAA;IACA,mBAAA;EAEF;AACF","sourcesContent":[".sales-message {\n  margin: 16px auto;\n  padding: 16px 20px;\n  max-width: 900px;\n  background: linear-gradient(135deg, #fff8e1 0%, #fff3cd 100%);\n  border: 1px solid #ffe082;\n  border-right: 4px solid #ffa726;\n  border-radius: 12px;\n  color: #5d4037;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 1.6;\n  text-align: center;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  direction: rtl;\n\n  @media (max-width: 768px) {\n    margin: 12px 10px;\n    padding: 12px 14px;\n    font-size: 14px;\n    border-radius: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
